import * as React from 'react';

export interface iRadioState {
    urlChanel: string,
    listSongs: Array<IAllVideos>,
}

interface IProps {
}

interface IThumbnailsVideo {
    url: string,
    width: string,
    height: string
}

interface IAllVideos {
    youtubeId: string,
    thumbnails: IThumbnailsVideo,
    videoTitle: string
}


export class App extends React.Component<IProps, iRadioState> {
    constructor(props: any) {
        super(props);
        this.state = {
            urlChanel: '',
            listSongs: [],
        };
        this.renderEmbedsVideos = this.renderEmbedsVideos.bind(this)
        this.extractAllList = this.extractAllList.bind(this)
    }

    componentDidMount(): void {
        this.extractAllList()
    }

    extractAllList() {
        const videoIds: Array<IAllVideos> = []
        const that = this
        const channelName = 'PLfJSJIO-ONydIDvnI_cLRUtmboygm5JnX';
        // @ts-ignore
        $.get(
            "https://www.googleapis.com/youtube/v3/playlistItems", {
                part: 'snippet',
                maxResults: 4,
                playlistId: channelName,
                key: 'AIzaSyAm0rzrIFXlVM0qljk8bG6Xfv4w4HA-zpg'
            },
            (data: any) => {
                data.items.forEach((item: any, i: number) => {
                    const videoId = item.snippet.resourceId.videoId;
                    const videoTitle = item.snippet.title;
                    const thumbnails = item.snippet.thumbnails.high;
                    videoIds.push({youtubeId: videoId, thumbnails, videoTitle})
                })
                that.setState({listSongs: videoIds})
            }
        );
    }


    renderEmbedsVideos() {
        return this.state.listSongs.map((item: IAllVideos, i: number) => {
                // @ts-ignore
                return (<a className="col-md-12 chart-youtube-link various no-ajaxy fancy"
                           data-fancybox-type="iframe"
                           key={i}
                           href={"/video/embedYoutube?id=" + item.youtubeId}>
                        <div className="media-left"><img style={{width: '100px'}} className="media-object"
                                                         src={item.thumbnails.url}
                                                         alt={item.videoTitle}/>
                        </div>
                        <div className="media-body">
                            <h4 className="media-heading" style={{color: '#606060'}}>{item.videoTitle}</h4>
                        </div>
                    </a>
                )
            }
        )
    }

    render() {
        return (
            <div className="col-lg-4 hidden-xs hidden-sm"
                 style={{
                     backgroundColor: '#f9f9f9',
                     display: 'block',
                     padding: 0,
                     width: '300px',
                     maxWidth: '300px',
                     maxHeight: '380px',
                     boxShadow: '0 0 3px 0 #9b9b9b',
                     marginBottom: '10px'
                 }}>
                <div style={{width: '100%', backgroundColor: '#f1f1f1', display: 'inline-block', padding: '5px'}}>
                    <div className="g-ytsubscribe" data-channel="bgradiobg" data-layout="full"
                         data-count="hidden"/>
                </div>

                {this.state.listSongs.length > 0 &&
                <div id="insta-widget-bg"
                     className="row"
                     style={{padding: '4px', maxHeight: '300px'}}
                >{this.renderEmbedsVideos()}</div>}
            </div>
        );
    }
}